import BadgeRating from "th/badgeRating";

export { BadgeRating };

customElements.define("th-badge-rating", BadgeRating.CustomElementConstructor);
